import "../../css/MobileMenu.css";
import Socials from "./Socials";

import { useSpring, animated } from "@react-spring/web";
import { useContext } from "react";
import { useMediaQuery } from "react-responsive";
import useFetch from "../../hooks/useFetch";
import { Link } from "react-router-dom";
import LanguageContext from "../../context/language-context";
export default function MobileMenu(props) {
  const springs = useSpring({
    from: { x: -100 },
    to: { x: 0 },
  });
  const languageCtx = useContext(LanguageContext);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const { loading, error, data } = useFetch(
    `https://spagnoladmin.spagnolcompany.it/api/headers?locale=${languageCtx.languageData}&populate[0]=Logo&populate[1]=White_Logo`
  );

  if (loading) return <p>Loading...</p>;
  return (
    <animated.div
      className={`mobileView menuMobile ${props.isopen ? "showing" : ""}`}
      style={{ ...springs }}
    >
      <div className="mobilemenu">
        <div className="menue">
          <ul className="menus">
            <li className="space">
              <Link to="/group" className="heading cataloghi">
                {data.data[0].attributes.Group}
              </Link>
            </li>
            <li className="space">
              <a href="/brand" className="hasDropDown heading prodotti">
                {data.data[0].attributes.Brand}
              </a>
            </li>
            <li className="space">
              <Link to="/contract" className="heading contatti">
                {data.data[0].attributes.Contract}
              </Link>
            </li>

            <li className="space">
              <Link to="/news" className="heading contatti">
                {data.data[0].attributes.News}
              </Link>
            </li>
            <li className="space">
              <Link to="/contatti" className="heading contatti">
                {data.data[0].attributes.Contatti}
              </Link>
            </li>
          </ul>
          {isMobile && (
            <Socials
              area={data.data[0].attributes.Area_Riservata}
              facebook={data.data[0].attributes.Facebook}
              instagram={data.data[0].attributes.Instagram}
              x={data.data[0].attributes.X}
              pinterest={data.data[0].attributes.Pinterest}
              youtube={data.data[0].attributes.Youtube}
            />
          )}
        </div>
      </div>
    </animated.div>
  );
}
